import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialDoiState: Dtos.TrialDoi & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    ardcTrialEntry: null,
    yearAvailable: null,
    doi: null,
    protocolLabel: null,
    protocol: null,
    dataDictionaryLabel: null,
    dataDictionary: null,
    citation: null,
    showOnPortal: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialDoiReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    ardcTrialEntry: IFieldState<string>,
    yearAvailable: IFieldState<number>,
    doi: IFieldState<string>,
    protocolLabel: IFieldState<string>,
    protocol: IFieldState<string>,
    dataDictionaryLabel: IFieldState<string>,
    dataDictionary: IFieldState<string>,
    citation: IFieldState<string>,
    showOnPortal: IFieldState<boolean>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    sourceDocuments: IFieldState<Dtos.SourceDocument[]>,
}
